import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';
import type { Tone } from '../components/Tone';
import { TONE_AREAS, areaOf } from '../components/ToneArea';
import type { ModuleId } from './nav-config';

// Each section of the app owns a colour, after Propel's module colours (DECISIONS-LOG
// 2026-10-05 "Colour per section"), in the area colours of 2026-10-06. The menu item, the
// strip under the header and every untoned card or table on the section's pages wear it.

export const SECTION_TONES: Readonly<Record<ModuleId, Tone>> = {
  dashboard: 'dashboard',
  organisation: 'organisation',
  requisitions: 'requisition',
  jobs: 'job',
  candidates: 'screening',
  assessments: 'assessment',
  interviews: 'interview',
  tasks: 'tasks',
  reports: 'reports',
  admin: 'admin',
  // A hiring manager's pages sit under /my/, which ToneArea puts in Requisitions.
  my_actions: 'requisition',
  my_openings: 'requisition',
  request_hire: 'requisition',
};

/** The colour of the section a path belongs to: its area's (ToneArea's map is the one map). */
export function sectionToneOf(pathname: string): Tone {
  return TONE_AREAS[areaOf(pathname)].tone;
}

/**
 * Puts the current section on <html> as `data-section`, which semantic.css turns into
 * `--nr-section`. An attribute, not a class: switching theme rewrites <html>'s class list.
 * Renders nothing, so navigating re-renders this and not the shell (CLAUDE.md §5a rule 6).
 */
export function SectionTone(): null {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const tone = sectionToneOf(pathname);

  useEffect(() => {
    document.documentElement.dataset.section = tone;
  }, [tone]);

  return null;
}
